/**
 * ネストしたオブジェクトdataから指定したキーの値を集めてarrayで返却する
 * keyは "subject_field_missions[].missions[].question_set.id" のように指定
 */
let nestedItems = function collect_nested_items(data: any, key: string, result: Array<any> = []) {
  let keys:Array<any> = key.split(".")
  let k:string = keys[0]
  let att_name: string
  let is_array: boolean
  if (k.endsWith("[]")) {
    att_name = k.slice(0, -2)
    is_array = true
  } else {
    att_name = k
    is_array = false
  }
  let value = data[att_name]
  if (value == undefined||value == null) {
    return
  }
  if (keys.length == 1) {
    // 値へアクセス
    if (value !== null) {
      result.push(value)
    }
  } else {
    keys.shift()
    let child_key = keys.join(".")
  	if (is_array) {
      for (let item of value) {
        if (item !== null) {
          collect_nested_items(item, child_key, result)
        }
      }
    } else {
      let v = collect_nested_items(value, child_key, result)
    }
    return result
  }
}

export {nestedItems}